// extracted by mini-css-extract-plugin
export var assigneeBadge = "_mv-0";
export var assigneeDetails = "_mv-1";
export var assigneeInfo = "_mv-2";
export var dropdownContainer = "_mv-4";
export var dropdownImage = "_mv-5";
export var editAssigneeInfo = "_mv-3";
export var editAssigneeModalContainer = "_mv-6";
export var hidden = "_mv-8";
export var input = "_mv-7";